import env from "$lib/env";
import { get } from "svelte/store";
import settings from "$lib/state/settings";

export const currentApiURL = () => {
    const processingSettings = get(settings).processing;
    const customInstanceURL = processingSettings.customInstanceURL;

    let url;
    if (processingSettings.enableCustomInstances && customInstanceURL.length > 0) {
        url = new URL(customInstanceURL).toString();
    } else {
        url = new URL(env.DEFAULT_API!).toString();
    }

    return url.endsWith("/") ? url : `${url}/`;
}
